import styled from 'styled-components'

export const CreateEditOperationModalContainer = styled.div`
    .form-group {
        .modal-input {
            margin: 5px 0px;
        }
    }
`
